/**
 *
 * Pill
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CrossIcon from '../../../assets/v2/CrossIcon';
import { Component } from './Pill.styles';

function Pill(props) {
  return <Component deleteIcon={<CrossIcon />} {...props} />;
}

Pill.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onDelete: PropTypes.func,
};

export default memo(Pill);
